<template>
  <app-report>
    <app-widget
      flat
      class-widget="sm10 offset-sm1 xs12"
    >
      <div slot="widget-content">
        <app-report-header
          :title="(regiao.nome) ? `${estado.nome} - Região ${regiao.nome}` : `${estado.nome} - Todas as regiões`"
        />
        <v-simple-table :dense="tableDense">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Cliente
                </th>
                <th class="text-center">
                  CPF
                </th>
                <th class="text-center">
                  Cidade/Estado
                </th>
                <th class="text-center">
                  Latitude
                </th>
                <th class="text-center">
                  Longitude
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="d-print-table-row"
                v-for="item in relatorio"
                :key="item.id"
              >
                <td v-text="item.cliente_nome" />
                <td
                  class="text-center"
                  v-text="item.cliente_cpf"
                />
                <td
                  class="text-center"
                  v-text="`${item.cidade_nome}`"
                />
                <td
                  class="text-center"
                  v-text="item.cliente_geo_latitude"
                />
                <td
                  class="text-center"
                  v-text="item.cliente_geo_longitude"
                />
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </app-widget>
  </app-report>
</template>
<script>
import AppReport from '@/components/layouts/AppReport'
import AppWidget from '@/components/AppWidget'
import AppReportHeader from '@/components/AppReportHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    AppReport,
    AppWidget,
    AppReportHeader
  },
  computed: {
    ...mapGetters(['relatorio', 'regiao', 'estado', 'openChart', 'tableDense'])
  }
}
</script>
